'use client';

import React from 'react';

export const ForbiddenPageContent = () => (
  <div>
    <h2>Forbidden</h2>
    <p>You do not have permissions to access this view</p>
  </div>
);
